<template>
    <v-app>
        <top-toolbar></top-toolbar>
        <v-content>
            <div style="padding: 15px">
                <door-row></door-row>
                <garage-row></garage-row>
            </div>
        </v-content>
    </v-app>
</template>

<script>
    import TopToolbar from "../components/TopToolbar";
    import DoorRow from "../components/DoorRow";
    import GarageRow from "../components/GarageRow";

    export default {
        name: 'Home',
        components: {
            GarageRow,
            DoorRow,
            TopToolbar
        },
        data () {
            return {
                //
            }
        }
    }
</script>
